import React from 'react'
import PropTypes from 'prop-types'

export default function PasswordCriteriaMet( props ) {    
    return (
        <>
            { props.visible &&
            <div className= { props.contentWrapper + ' c-password-checklist' } >
                <p className="c-password-checklist__title" aria-label= { props.dynamicADAMsg } tabIndex={ 0 }>Password must include:</p>
                <ul className="c-password-checklist__list" >
                    <li className={ props.pswLength }>minimum of 8 characters</li>
                    <li className={ props.pswLetter }>one letter</li>
                    <li className={ props.pswNumber }>one number</li>
                    <li className={ props.pswSpecial }>one symbol / special character</li>
                </ul>
            </div>
            }
        </>
    )
}

PasswordCriteriaMet.propTypes = {
    visible: PropTypes.bool,
    pswLength: PropTypes.string,
    pswSpecial: PropTypes.string,
    pswNumber: PropTypes.string,
    pswLetter: PropTypes.string,
    contentWrapper: PropTypes.string,
    dynamicADAMsg : PropTypes.string
}
